import { authorizedRequest, logout } from './account';
import { responseError } from './errors';

require('dotenv').config();

const ENV = process.env;

export const REQUEST_TODAYS = 'REQUEST_TODAYS';
export const RECEIVE_TODAYS = 'RECEIVE_TODAYS';
export const RECEIVE_TODAY = 'RECEIVE_TODAY';

export const requestTodays = () => ({
  type: REQUEST_TODAYS,
});

export const receivedTodays = json => ({
  type: RECEIVE_TODAYS,
  json,
});

export const receivedToday = json => ({
  type: RECEIVE_TODAY,
  json,
});

export const createToday = params => (
  (dispatch) => {
    dispatch(requestTodays());
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return authorizedRequest(`${ENV.REACT_APP_API_SERVER}/today-crud`, { method: 'POST', headers, body: JSON.stringify(params) })
      .then(
        response => (response.status === 200 ? response.json() : response),
        error => error,
      )
      .then((json) => {
        if (String(json).includes('TypeError')) {
          dispatch(responseError('Problems with server'));
        } else if (json.status === 401) {
          dispatch(responseError('Unauthorized'));
        }
        return json;
      });
  }
);

export const deleteToday = id => (
  (dispatch) => {
    dispatch(requestTodays());
    return authorizedRequest(`${ENV.REACT_APP_API_SERVER}/today-crud/${id}`, { method: 'DELETE', headers: {} })
      .then(
        response => (response.status === 200 ? response.json() : response),
        error => error,
      )
      .then((json) => {
        if (String(json).includes('TypeError')) {
          dispatch(responseError('Problems with server'));
        } else if (json.status === 401) {
          dispatch(responseError('Unauthorized'));
        }
        return json;
      });
  }
);

export const fetchTodays = sort => (
  (dispatch) => {
    dispatch(requestTodays());
    let url = `${ENV.REACT_APP_API_SERVER}/today-crud`;
    if (sort) url += `?order=${JSON.stringify(sort)}`;
    return authorizedRequest(url, { method: 'GET' })
      .then(
        response => (response.status === 200 ? response.json() : response),
        error => error,
      )
      .then((json) => {
        if (String(json).includes('TypeError')) {
          dispatch(responseError('Problems with server'));
          dispatch(receivedTodays([]));
        } else if (json.status === 401) {
          dispatch(logout());
          dispatch(receivedTodays([]));
        } else {
          dispatch(receivedTodays({ data: json.today } || []));
        }
        return json.today;
      });
  }
);

export const fetchToday = id => (
  (dispatch) => {
    dispatch(requestTodays());
    return authorizedRequest(`${ENV.REACT_APP_API_SERVER}/today-crud/${id}`, { method: 'GET' })
      .then(
        response => (response.status === 200 ? response.json() : response),
        error => error,
      )
      .then((json) => {
        if (String(json).includes('TypeError')) {
          dispatch(responseError('Problems with server'));
        } else if (json.status === 401) {
          dispatch(logout());
        } else {
          dispatch(receivedToday(json.today));
        }
        return json.today;
      });
  }
);

export const saveToday = (id, params) => (
  (dispatch) => {
    dispatch(requestTodays());
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return authorizedRequest(`${ENV.REACT_APP_API_SERVER}/today-crud/${id}`, { method: 'POST', headers, body: JSON.stringify(params) })
      .then(
        response => (response.status === 200 ? response.json() : response),
        error => error,
      )
      .then((json) => {
        if (String(json).includes('TypeError')) {
          dispatch(responseError('Problems with server'));
        } else if (json.status === 401) {
          dispatch(responseError('Unauthorized'));
        }
        return json;
      });
  }
);
